import React, { useMemo, useCallback } from "react";
import PropTypes from "prop-types";
import {
  Box,
  TextField,
  InputAdornment,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { DataGrid, 
  // GridPagination 
} from "@mui/x-data-grid";
import SearchIcon from "@mui/icons-material/Search";

const ReusabletableComponent = ({
  columns,
  rows,
  title,
  searchPlaceholder,
  page,
  pageSize,
  rowCount,
  onPageChange,
  onPageSizeChange,
  onSearchChange,
  searchText,
  loading,
}) => {
  const isMobile = useMediaQuery("(max-width:600px)");

  const handleSearchChange = useCallback(
    (event) => {
      const value = event.target.value;
      onSearchChange(value);
    },
    [onSearchChange]
  );


  // 🔹 On mobile, ensure each column has a minWidth applied
  const adjustedColumns = useMemo(() => {
    if (!isMobile) return columns;
    return columns.map((col) => ({
      ...col,
      minWidth: col.width || 150,
      flex: 0, // prevent flex shrinking on small screens
    }));
  }, [columns, isMobile]);

  return (
    <Box
      sx={{
        p: 2,
        backgroundColor: "#fff",
        borderRadius: 2,
        boxShadow: 1,
        overflowX: "auto", // horizontal scroll for mobile
      }}
    >
      {title && (
        <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
          {title}
        </Typography>
      )}

      {/* Search Field */}
      <TextField
        placeholder={searchPlaceholder || "Search..."}
        variant="outlined"
        fullWidth
        size="small"
        sx={{ mb: 2 }}
        onChange={handleSearchChange}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon color="action" />
            </InputAdornment>
          ),
        }}
      />

      {/* DataGrid */}
      <Box
        sx={{
          height: isMobile ? 400 : 440,
          width: "100%",
          overflowX: "auto",
          "& .MuiDataGrid-columnHeaders": {
            position: "sticky",
            top: 0,
            zIndex: 1,
            backgroundColor: "#F4F6F8",
          },
        }}
      >
        <DataGrid
          rows={rows}
          columns={adjustedColumns.map((col) => ({
            ...col,
            flex: col.flex ?? (isMobile ? undefined : 1), // only default flex if not defined
          }))}
          paginationMode="server"
          rowCount={rowCount}
          page={page}
          pageSize={pageSize}
          onPaginationModelChange={(model) => {
            onPageChange(model.page);
            onPageSizeChange(model.pageSize);
          }}
          paginationModel={{ page, pageSize }}
          pageSizeOptions={[5, 10, 20, 50]}
          //loading={loading}
          // initialState={{
          //   pagination: { paginationModel: { pageSize: 5, page: 0 } },
          // }}
          disableRowSelectionOnClick
          disableColumnMenu
          disableColumnResize
          disableColumnReorder
          // slots={{
          //   pagination: GridPagination,
          // }}
          sx={{
            border: "none",
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: "#F4F6F8",
              fontWeight: 600,
              borderBottom: "1px solid #e0e0e0",
              color: "rgba(99, 115, 129, 1)",
            },
            "& .MuiDataGrid-cell": {
              border: "none",
              fontSize: "14px",
            },
            "& .MuiDataGrid-footerContainer": {
              borderTop: "1px solid #e0e0e0",
              justifyContent: "space-between",
              flexWrap: "wrap",
              px: 1,
              py: 0.5,
            },
            "& .MuiTablePagination-root": {
              fontSize: "0.8rem",
            },
          }}
        />
      </Box>
    </Box>
  );
};



ReusabletableComponent.propTypes = {
  columns: PropTypes.array,
  loading: PropTypes.any,
  onPageChange: PropTypes.func,
  onPageSizeChange: PropTypes.func,
  onSearchChange: PropTypes.func,
  page: PropTypes.number,
  pageSize: PropTypes.number,
  rowCount: PropTypes.number,
  rows: PropTypes.array,
  searchPlaceholder: PropTypes.any,
  searchText: PropTypes.any,
  title: PropTypes.any,
};

export default ReusabletableComponent;
